import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton,
  Paper,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import logo from "../../assets/logostx.jpg";
import API from "../../services/api";
import CustomSnackBar from "../../components/CustomSnackBar";

function Register() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [openSnack, setOpenSnack] = useState(false);
  const [loading, setLoading] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [snackSeverity, setSnackSeverity] = useState("info");

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordValid, setPasswordValid] = useState(false);
  const [passwordMatch, setPasswordMatch] = useState(true);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    username: "",
    password1: "",
    password2: "",
  });

  const validatePassword = (password) => {
    const isValid =
      password.length >= 8 &&
      /[A-Z]/.test(password) &&
      /[a-z]/.test(password) &&
      /\d/.test(password) &&
      /[!@#$%^&.*]/.test(password);
    setPasswordValid(isValid);
  };

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    validatePassword(newPassword);
    setPasswordMatch(newPassword === confirmPassword);
    setFormData({ ...formData, password1: newPassword });
  };

  const handleConfirmPasswordChange = (e) => {
    const newConfirmPassword = e.target.value;
    setConfirmPassword(newConfirmPassword);
    setPasswordMatch(newConfirmPassword === password);
    setFormData({ ...formData, password2: newConfirmPassword });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: name === "username" ? value.toLowerCase() : value,
    });
  };
  

  const handleSumbti = async () => {
    try {
      setLoading(true);
      const response = await API.post("auth/registration/", formData);
      console.log(response);
      setOpenSnack(true);
      setSnackMessage("¡Usuario registrado con éxito!");
      setSnackSeverity("success");
      setTimeout(() => {
        navigate("/login");
      }, 1500);
    } catch (error) {
      setOpenSnack(true);
      if (error.response && error.response.data && error.response.data.username) {
        setSnackMessage(error.response.data.username[0]);
        setSnackSeverity("error");
      } else {
        setSnackMessage("Algo salió mal, intente de nuevo");
        setSnackSeverity("error");
      }
      setLoading(false);
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      bgcolor="#10173c"
      minHeight="100vh" // Use minHeight to ensure full viewport coverage
      width="100%"
    >
      <Paper
        elevation={6}
        sx={{
          padding: "20px", // Reduced padding
          width: { xs: "90%", sm: "350px" }, // Responsive width
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "7px",
        }}
      >
        <img src={logo} alt="Logo" width={80} style={{ borderRadius: "5px" }} /> {/* Reduced logo size */}
        <Typography variant="h6" sx={{ fontWeight: "bold", color: "#10173c" }}> {/* Reduced Typography size */}
          Registro de usuario
        </Typography>

        <TextField
          fullWidth
          label="Nombre"
          variant="outlined"
          name="first_name"
          value={formData.first_name}
          onChange={handleInputChange}
        />
        <TextField
          fullWidth
          label="Apellido"
          variant="outlined"
          name="last_name"
          value={formData.last_name}
          onChange={handleInputChange}
        />
        <TextField
          fullWidth
          label="Usuario"
          variant="outlined"
          name="username"
          value={formData.username}
          onChange={handleInputChange}
        />
        <TextField
          fullWidth
          label="Correo"
          variant="outlined"
          type="email"
          name="email"
          value={formData.email}
          onChange={handleInputChange}
        />

        <FormControl fullWidth>
          <InputLabel>Contraseña</InputLabel>
          <OutlinedInput
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={handlePasswordChange}
            endAdornment={
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            label="Contraseña"
          />
        </FormControl>
        <Typography variant="caption" color={passwordValid ? "green" : "red"}>
          {passwordValid
            ? "Contraseña segura"
            : "Mín. 8 caracteres, mayúscula, minúscula, número y símbolo"}
        </Typography>

        <FormControl fullWidth variant="outlined">
          <InputLabel>Confirmar contraseña</InputLabel>
          <OutlinedInput
            type={showConfirmPassword ? "text" : "password"}
            value={confirmPassword}
            onChange={handleConfirmPasswordChange}
            endAdornment={
              <InputAdornment position="end">
                <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)} edge="end">
                  {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            label="Confirmar contraseña"
          />
        </FormControl>
        <Typography variant="caption" color={passwordMatch ? "green" : "red"}>
          {passwordMatch ? "Las contraseñas coinciden" : "Las contraseñas no coinciden"}
        </Typography>

        <Button
          variant="contained"
          color="primary"
          sx={{ fontSize: "10px", marginTop: "10px" }}
          fullWidth
          disabled={!passwordValid || !passwordMatch || loading}
          onClick={handleSumbti}
          loading={loading}
        >
          {loading ? "Registrando..." : "Registrarse"}
        </Button>

        <Typography variant="body2">o</Typography>

        <Button
          variant="contained"
          color="secondary"
          sx={{ fontSize: "10px" }}
          fullWidth
          onClick={() => navigate("/")}
        >
          Iniciar sesión
        </Button>
      </Paper>
      {openSnack && (
        <CustomSnackBar open={openSnack} setOpen={setOpenSnack} message={snackMessage} severity={snackSeverity} />
      )}
    </Box>
  );
}

export default Register;